module.exports = __webpack_public_path__ + "img/search.6f32e95b.svg";